import messages_en from './assets/locale/messages_en.json';
import { getCustomerRewardCondition } from './getCustomerRewardCondition';
import { getCustomerRewardTitle } from './getCustomerRewardTitle';
import { getCustomerTitle } from './getCustomerTitle';
import { getFriendRewardCondition } from './getFriendRewardCondition';
import { getFriendRewardTitle } from './getFriendRewardTitle';
import { getFriendTitle } from './getFriendTitle';
const DEFAULT_LANGUAGE = 'en';
const NAMESPACE = 'reward-descriptions';
export async function loadRewardDescriptions(_ref) {
  let {
    i18n,
    ...otherParams
  } = _ref;
  const {
    language
  } = i18n;
  i18n.addResources(DEFAULT_LANGUAGE, NAMESPACE, messages_en);
  if (language !== DEFAULT_LANGUAGE) {
    try {
      const resources = await import(`./assets/locale/messages_${language}.json`);
      i18n.addResources(language, NAMESPACE, resources);
    } catch {}
  }
  const t = i18n.getFixedT(null, NAMESPACE);
  const context = {
    ...otherParams,
    t
  };
  return {
    getFriendTitle: getFriendTitle.bind(undefined, context),
    getFriendRewardTitle: getFriendRewardTitle.bind(undefined, context),
    getFriendRewardCondition: getFriendRewardCondition.bind(undefined, context),
    getCustomerTitle: getCustomerTitle.bind(undefined, context),
    getCustomerRewardTitle: getCustomerRewardTitle.bind(undefined, context),
    getCustomerRewardCondition: getCustomerRewardCondition.bind(undefined, context)
  };
}
//# sourceMappingURL=loadRewardDescriptions.js.map